// Where someone came from when they opened the app itself (not the marketing site): the URL
// parameters of the first address they landed on this visit (utm_*, src, ad click ids), the
// address and the site that sent them. Kept for this tab only and sent with the start form; the
// API keeps it on the take and in HubSpot (ad consent only governs what Meta and GA4 hear).

// gp_sl: the short link it came through (giftsprofile.com/<slug>), for reports.
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid", "ttclid", "msclkid", "src", "gp_sl"] as const;
const STORE = "gp_app_touch";

export type LandingTouch = Partial<Record<(typeof KEYS)[number] | "landing" | "referrer" | "at", string>>;

/** Remembers this visit's landing (once per tab: the first address with parameters, or from another site, wins). */
export function captureLanding(loc: Location = location, referrer: string = document.referrer): void {
  try {
    if (sessionStorage.getItem(STORE)) return;
    const params = new URLSearchParams(loc.search);
    const touch: LandingTouch = {};
    for (const k of KEYS) {
      const v = params.get(k);
      if (v) touch[k] = v.slice(0, 120);
    }
    const external = referrer && !referrer.startsWith(loc.origin) ? referrer.slice(0, 200) : undefined;
    if (!Object.keys(touch).length && !external) return;
    sessionStorage.setItem(STORE, JSON.stringify({ ...touch, landing: `${loc.pathname}${loc.search}`.slice(0, 200), ...(external ? { referrer: external } : {}), at: new Date().toISOString() }));
  } catch {
    // No storage (private mode, blocked): nothing to remember.
  }
}

/** This visit's landing, if it had anything worth keeping. */
export function landingTouch(): LandingTouch | undefined {
  try {
    const raw = sessionStorage.getItem(STORE);
    return raw ? (JSON.parse(raw) as LandingTouch) : undefined;
  } catch {
    return undefined;
  }
}
